import { useCallback, useEffect, useState } from 'react';
import { analystApi } from 'api';
import './BeboMascot.css';

const SEV = {
  high: { dot: '#EF6F6C', label: 'Alta' },
  medium: { dot: '#F2C14E', label: 'Media' },
  low: { dot: '#7AD1A0', label: 'Baja' },
};

// --- Bebo the baby buddha: a chubby seated monk drawn as a pixel-art sprite. ---
// The body is a fixed pixel grid (BUDA_BASE); the face swaps per mood (happy /
// concerned / angry) via small pixel overlays (BUDA_FACES). To restyle, edit the
// grid/overlays directly — each char maps to a color in BUDA_PAL ('.' = empty).
const BUDA_W = 40;
const BUDA_H = 46;
const BUDA_PAL = {
  K: '#2a1c0b',
  o: '#f2cd84', d: '#d9a64e', l: '#fce7b4', r: '#e88a5c',
  R: '#d9822a', s: '#a85d18', h: '#f2a64a',
  W: '#ffffff', m: '#7a2f1f',
};
const BUDA_BASE = [
  '........................................',
  '........................................',
  '..................KKKKK.................',
  '.................KoooooK................',
  '...............KKoooooooKK..............',
  '..............KoooooooooooK.............',
  '.............KoooooooooooooK............',
  '............KoolllooooooooooK...........',
  '...........KoolllllooooooooooK..........',
  '...........KoolllllooooooooooK..........',
  '..........KooollllloooooooooooK.........',
  '.........KKoooolllooooooooooooKK........',
  '........KoooooooooooooooooooooooK.......',
  '........KoooooooooooooooooooddooK.......',
  '........KoooorrrooooooooorrrddooK.......',
  '........KoooorrrooooooooorrrddooK.......',
  '........KoooorrrooooooooorrrddooK.......',
  '.........KKKoooooooooooooodddKKK........',
  '...........KoooooooooooooddddK..........',
  '............KoooooooooooodddK...........',
  '............KKoooooooooooddKK...........',
  '...........KRRRoooooooooodRRRK..........',
  '..........KRRRRRRoooooooRRRRRRK.........',
  '.........KRRRRRRRRRoooRRRRRRRRRK........',
  '.........KRRssRRRhRRoRRRRRRRRRRK........',
  '........KRRRhhsshhhhRRRRRRRRRRRRK.......',
  '........KRRRRRhssshhhRRRRsRRRRRRK.......',
  '.......KRRRRRRhshhsshRRRRsRRRRRRRK......',
  '.......KRRRRRhssshhhssRRsssRRRRRRK......',
  '.......KRRRRRRssshhhhhsssssRRRRRRK......',
  '.......KRRRRRRssshhhsRhhsssssssRRK......',
  '......KRRRRRRRssshhhsRRRssssssssRRK.....',
  '......KRRRRRRRssshRRsRRRsssssssssRK.....',
  '.......KRRRRRRsssRRRsRRRsssssssssK......',
  '.......KRRoooRsssRRRsRRsssssooossK......',
  '.......KRooooosssRRRsRsssssooooosK......',
  '.......KooooooossRRRssssssoooooooK......',
  '......KKRoooooRsRRRRsssssssooooosKK.....',
  '.....KRRRRoooRRsRRRRssssssssooossRRK....',
  '.....KRRRRRRRoooRRRRsssssooossssRRRK....',
  '....KRRRRRRRoooooRRRsRssooooossRRRRRK...',
  '.....KRRRRsooooooosssssooooooosRRRRK....',
  '.....KRsssssooooosssssssooooosssssRK....',
  '......KKsssssooosssssssssooosssssKK.....',
  '........KsssssssssssssssssssssssK.......',
  '.........KKKsssssssssssssssssKKK........',
];
const BUDA_FACES = {
  happy: [[15,12,'K'],[16,11,'K'],[17,11,'K'],[18,12,'K'],[23,12,'K'],[24,11,'K'],[25,11,'K'],[26,12,'K'],[17,16,'K'],[18,16,'K'],[19,16,'K'],[20,16,'K'],[21,16,'K'],[22,16,'K'],[23,16,'K'],[18,17,'W'],[19,17,'W'],[20,17,'W'],[21,17,'W'],[22,17,'W'],[17,17,'K'],[23,17,'K'],[18,18,'m'],[19,18,'m'],[20,18,'m'],[21,18,'m'],[22,18,'m'],[17,18,'K'],[23,18,'K'],[19,19,'K'],[20,19,'K'],[21,19,'K']],
  concerned: [[15,11,'W'],[15,12,'W'],[16,11,'W'],[16,12,'W'],[17,11,'W'],[17,12,'W'],[16,11,'K'],[16,12,'K'],[17,12,'K'],[23,11,'W'],[23,12,'W'],[24,11,'W'],[24,12,'W'],[25,11,'W'],[25,12,'W'],[24,11,'K'],[24,12,'K'],[25,12,'K'],[14,9,'K'],[15,9,'K'],[16,9,'K'],[23,9,'K'],[24,9,'K'],[25,9,'K'],[18,18,'K'],[19,18,'K'],[20,18,'K'],[21,18,'K'],[22,18,'K'],[17,19,'K'],[23,19,'K']],
  angry: [[15,11,'W'],[15,12,'W'],[16,11,'W'],[16,12,'W'],[17,11,'W'],[17,12,'W'],[16,11,'K'],[16,12,'K'],[17,12,'K'],[23,11,'W'],[23,12,'W'],[24,11,'W'],[24,12,'W'],[25,11,'W'],[25,12,'W'],[24,11,'K'],[24,12,'K'],[25,12,'K'],[13,10,'K'],[14,10,'K'],[15,11,'K'],[16,11,'K'],[24,11,'K'],[25,11,'K'],[26,10,'K'],[27,10,'K'],[18,19,'K'],[19,19,'K'],[20,19,'K'],[21,19,'K'],[22,19,'K'],[19,18,'m'],[20,18,'m'],[21,18,'m'],[18,18,'K'],[22,18,'K'],[19,17,'K'],[20,17,'K'],[21,17,'K']],
};

// Precompute run-length-encoded rects per mood: [x, y, width, colorChar].
const BUDA_SPRITES = Object.fromEntries(
  Object.keys(BUDA_FACES).map((mood) => {
    const grid = BUDA_BASE.map((row) => row.split(''));
    BUDA_FACES[mood].forEach(([x, y, c]) => { grid[y][x] = c; });
    const rects = [];
    for (let y = 0; y < grid.length; y += 1) {
      let x = 0;
      while (x < grid[y].length) {
        const c = grid[y][x];
        if (c === '.') { x += 1; continue; }
        let w = 1;
        while (x + w < grid[y].length && grid[y][x + w] === c) w += 1;
        rects.push([x, y, w, c]);
        x += w;
      }
    }
    return [mood, rects];
  }),
);

function BudaMascot({ mood, waving }) {
  const rects = BUDA_SPRITES[mood] || BUDA_SPRITES.happy;
  return (
    <svg className={`buda-sprite${waving ? ' wave' : ''}`} viewBox={`0 0 ${BUDA_W} ${BUDA_H}`}
      xmlns="http://www.w3.org/2000/svg" shapeRendering="crispEdges" aria-hidden="true">
      {rects.map(([x, y, w, c], i) => (
        <rect key={i} x={x} y={y} width={w} height="1" fill={BUDA_PAL[c]} />
      ))}
    </svg>
  );
}

function InsightCard({ ins, onState, onAsk }) {
  const [open, setOpen] = useState(false);
  const sev = SEV[ins.severity] || SEV.low;
  const period = ins.evidence?.period;
  const explanation = ins.evidence?.explanation;
  return (
    <div className="bebo-ins-card">
      <div className="bebo-ins-head">
        <span className="bebo-ins-dot" style={{ background: sev.dot }} />
        <span className="bebo-ins-title">{ins.title}</span>
      </div>
      <div className="bebo-ins-detail">{ins.detail}</div>
      {period?.now && (
        <div className="bebo-ins-period">
          📅 {period.prior ? `${period.now} vs. ${period.prior}` : period.now}
        </div>
      )}
      {explanation && (
        <>
          <button
            type="button"
            className="bebo-ins-more"
            onClick={() => setOpen((o) => !o)}
            aria-expanded={open}
          >
            {open ? 'Ver menos ▴' : 'Ver más ▾'}
          </button>
          {open && <div className="bebo-ins-explain">{explanation}</div>}
        </>
      )}
      <div className="bebo-ins-actions">
        <button type="button" onClick={() => onAsk(ins)}>💬 Preguntar</button>
        <button type="button" onClick={() => onState(ins.id, 'snoozed')}>💤 Posponer</button>
        <button type="button" onClick={() => onState(ins.id, 'dismissed')}>✕ Descartar</button>
      </div>
    </div>
  );
}

function BeboMascot({ brand, onAsk }) {
  const [insights, setInsights] = useState([]);
  const [badge, setBadge] = useState(0);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const load = useCallback(async () => {
    if (!brand) return;
    setLoading(true);
    try {
      const res = await analystApi.getInsights(brand);
      setInsights(res?.insights || []);
      setBadge(res?.badge || 0);
    } catch (_e) {
      // silencioso: la mascota no molesta si falla
    } finally {
      setLoading(false);
    }
  }, [brand]);

  useEffect(() => {
    setOpen(false);
    load();
  }, [load]);

  const handleState = useCallback(async (id, state) => {
    setInsights((cur) => cur.filter((i) => i.id !== id));
    setBadge((b) => Math.max(0, b - 1));
    try {
      await analystApi.setInsightState(id, state);
    } catch (_e) {
      load();
    }
  }, [load]);

  const ask = useCallback((ins) => {
    setOpen(false);
    onAsk?.(`Contame más sobre esto: ${ins.title}. ${ins.detail}`);
  }, [onAsk]);

  const toggle = () => {
    setOpen((o) => !o);
    if (!open) load();
  };

  const mood = insights.some((i) => i.severity === 'high')
    ? 'angry'
    : insights.length
      ? 'concerned'
      : 'happy';

  return (
    <div className="bebo-mascot-root">
      {open && (
        <div className="bebo-ins-panel" role="dialog" aria-label="Insights de Bebo">
          <div className="bebo-ins-panel-head">
            <span>Bebo encontró</span>
            <button type="button" className="bebo-ins-close" onClick={() => setOpen(false)}>×</button>
          </div>
          <div className="bebo-ins-list">
            {loading && insights.length === 0 && (
              <div className="bebo-ins-empty">Revisando tu cuenta…</div>
            )}
            {!loading && insights.length === 0 && (
              <div className="bebo-ins-empty">Todo en orden por acá ✨</div>
            )}
            {insights.map((ins) => (
              <InsightCard key={ins.id} ins={ins} onState={handleState} onAsk={ask} />
            ))}
          </div>
        </div>
      )}
      <button
        type="button"
        className={`bebo-mascot mood-${mood}${badge > 0 ? ' has-news' : ''}`}
        onClick={toggle}
        aria-label={badge > 0 ? `Bebo tiene ${badge} insights` : 'Bebo'}
        title={badge > 0 ? `Bebo encontró ${badge} cosas` : 'Bebo'}
      >
        <BudaMascot mood={mood} waving={badge > 0} />
        {badge > 0 && <span className="bebo-mascot-badge">{badge}</span>}
      </button>
    </div>
  );
}

export default BeboMascot;
